import { Button, DialogActions, DialogContent } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import AttachmentIcon from "@mui/icons-material/Attachment";
import PreviewIcon from "@mui/icons-material/Preview";
import styles from "./styles.module.css";

const Step1 = ({
  pdfUrl,
  setPdfUrl,
  setFileKey,
  setOpenVisualizador,
  setPdfName,
  handleAvancar,
  pdfName,
  handleCloseModal,
}) => {
  const preventDefault = (event) => event.preventDefault();

  const handleFileDrop = (event) => {
    preventDefault(event);
    const file = event.dataTransfer.files[0];
    handleFile(file);
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    
    handleFile(file);
  };

  const handleFile = (file) => {
    if (file && file.type === "application/pdf") {
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl);
      }

      
      
      const fileUrl = URL.createObjectURL(file);
      setPdfUrl(fileUrl);
      setFileKey((prev) => prev + 1);
      setOpenVisualizador(true);
      const fileName = file.name;
      setPdfName(fileName);
    } else {
      alert("Por favor, envie apenas arquivos PDF.");
    }
  };

  return (
    <>
      <DialogContent>
        <div
          onDrop={handleFileDrop}
          onDragOver={preventDefault}
          onDragEnter={preventDefault}
          className={styles.container_upload}
        >
          {pdfUrl ? (
            <>
              <AttachmentIcon sx={{ fontSize: "8rem" }} />
              <p>{pdfName}</p>
              <p>
                Clique ou arraste um novo arquivo para trocar o contrato
                selecionado
              </p>
            </>
          ) : (
            <>
              <UploadFileIcon sx={{ fontSize: "8rem" }} />
              <p>Arraste e solte o contrato aqui ou clique para selecionar</p>
            </>
          )}
          <input
            type="file"
            accept="application/pdf"
            onChange={handleFileSelect}
            className={styles.input}
          />
        </div>
        {pdfUrl && (
          <Button
            variant="contained"
            fullWidth
            className={styles.btn_visualizador}
            startIcon={<PreviewIcon />}
            onClick={() => setOpenVisualizador(true)}
          >
            Pré-vizualize o Contrato
          </Button>
        )}
        <DialogActions className={styles.container_btn}>
          <Button
            className={styles.btn_close}
            onClick={handleCloseModal}
            variant="outlined"
          >
            Fechar
          </Button>
          <Button
            className={pdfUrl ? styles.btn_avancar : ""}
            onClick={handleAvancar}
            variant="contained"
            disabled={!pdfUrl}
          >
            Avançar
          </Button>
        </DialogActions>
      </DialogContent>
    </>
  );
};

export default Step1;
